import { render, staticRenderFns } from "./SuperagentReport.vue?vue&type=template&id=8cd163c4"
import script from "./SuperagentReport.vue?vue&type=script&lang=js"
export * from "./SuperagentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports